import { OnInit, EventEmitter, ElementRef } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { SummaryService } from '../services/summary.service';
var BroadcastComponent = /** @class */ (function () {
    function BroadcastComponent(workspaceService, themeSettingService, summaryService) {
        var _this = this;
        this.workspaceService = workspaceService;
        this.themeSettingService = themeSettingService;
        this.summaryService = summaryService;
        this.returnObject = new EventEmitter();
        this.opened = false;
        this.forceRefresh = false;
        this.isBusy = false;
        this.hasNew = false;
        this.summaryService.hasNewMessagesChanged$.subscribe(function (result) {
            _this.setHasNew(result);
        });
    }
    BroadcastComponent.prototype.ngOnInit = function () {
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
    };
    BroadcastComponent.prototype.submit = function (message) {
        var _this = this;
        if (message) {
            this.isBusy = true;
            var param = [];
            param.push({ name: 'DocType', value: this.docType });
            param.push({ name: 'DocId', value: this.docId });
            param.push({ name: 'Message', value: message });
            this.workspaceService.executeGenericWorkflow(this.broadcastAction, param).subscribe(function (result) {
                var resultObject = JSON.parse(result);
                _this.isBusy = false;
                _this.input.nativeElement.value = "";
                _this.returnObject.emit(result);
                switch (resultObject.RefreshType) {
                    case "self":
                        _this.forceRefresh = !_this.forceRefresh;
                        break;
                    case "parent":
                        _this.forceRefresh = !_this.forceRefresh;
                        _this.getEPICParent(false, resultObject.ReturnType);
                        break;
                    case "all":
                        _this.forceRefresh = !_this.forceRefresh;
                        _this.getEPICParent(true, resultObject.ReturnType);
                        break;
                }
            }, function (error) {
                _this.isBusy = false;
            });
        }
    };
    BroadcastComponent.prototype.getEPICParent = function (findAllParent, returnType) {
        var _this = this;
        if (findAllParent) {
            this.workspaceService.getAllParentsEPICId(this.detailId).subscribe(function (result) {
                if (result) {
                    var array = JSON.parse(result);
                    array.forEach(function (id) {
                        _this.workspaceService.setParentId(id);
                    });
                }
            });
        }
        else {
            this.workspaceService.getParentEPICId(this.detailId).subscribe(function (result) {
                _this.workspaceService.setParentId(result);
            });
        }
    };
    BroadcastComponent.prototype.setHasNew = function (bool) {
        if (!this.opened) {
            this.hasNew = bool;
        }
    };
    BroadcastComponent.prototype.togglePopover = function (pre) {
        this.opened = pre;
        if (this.opened) {
            this.hasNew = false;
        }
    };
    return BroadcastComponent;
}());
export { BroadcastComponent };
